
<!-- Dialog Header -->
<div class="det-header" mat-dialog-title>
  <div class="det-header-icon-wrap">
    @if (data.type === 'Admin') {
      <ion-icon name="key-outline" class="det-header-icon det-header-icon--admin"></ion-icon>
    } @else if (data.type === 'Manager') {
      <ion-icon name="briefcase-outline" class="det-header-icon det-header-icon--manager"></ion-icon>
    } @else if (data.type === 'Leader') {
      <ion-icon name="ribbon-outline" class="det-header-icon det-header-icon--leader"></ion-icon>
    } @else {
      <ion-icon name="people-outline" class="det-header-icon det-header-icon--member"></ion-icon>
    }
  </div>
  <div class="det-header-copy">
    <span class="det-header-kicker">Team Management</span>
    <span class="det-header-title">
      @if (data.type === 'Member') { Select Members } @else { Select {{ data.type }}  }
    </span>
  </div>
  <button mat-icon-button mat-dialog-close class="det-close-btn" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="det-content">
  <div class="det-list-hint">
    @if (data.type === 'Member') {
      <ion-icon name="checkbox-outline"></ion-icon>
      <span>Select one or more members</span>
    } @else {
      <ion-icon name="radio-button-on-outline"></ion-icon>
      <span>Select one person for this role</span>
    }
  </div>

  <mat-selection-list
    class="det-selection-list"
    [(ngModel)]="selectedOptions"
    [multiple]="data.type === 'Member' ? true : false">
    @for (item of data.empList; track item.Id) {
      <mat-list-option
        class="det-list-option"
        [value]="item.Id"
        togglePosition="before"
        [selected]="item.isSelected">
        <div class="det-option-inner">
          <div class="det-option-avatar">
            <ion-icon name="person-outline"></ion-icon>
          </div>
          <span class="det-option-name">{{ item.Name }}</span>
          <ion-icon name="checkmark-circle" class="det-option-check"></ion-icon>
        </div>
      </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="det-actions">
  <button mat-button mat-dialog-close class="det-btn det-btn--cancel">
    <mat-icon>close</mat-icon>
    Cancel
  </button>
  <button mat-button mat-dialog-close class="det-btn det-btn--confirm" cdkFocusInitial (click)="updateMember()">
    <mat-icon>check_circle</mat-icon>
    Update
  </button>
</mat-dialog-actions>
